import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import TagsAnchorContainer from "../TagsAnchorContainer";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicApercutProfil = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Gérer votre compte', link: '/topics/compte/gestion-compte'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Utilisez<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/personal-info`}>votre profil</a>
              pour accélérer votre inscription aux compétitions. Les informations que vous avez fournies seront automatiquement préremplies 
              tout au long de votre expérience sur Wodzone.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-56" ref={anchorsParts[0].ref}>
              <p className="help-title-part mb-8">{anchorsParts[0].content}</p>
              <p className="help-text">
                Les informations de votre profil sont visibles sur Wodzone uniquement dans le menu déroulant "Sélection des athlètes" pour la composition 
                de votre équipe. Par la suite, seuls les organisateurs auront accès à vos données essentielles (nom, prénom, sexe).
              </p>
              <p className="help-text mt-24">
                Soucieux de protéger votre vie privée, nous garantissons que toutes les autres informations ne seront ni transmises aux organisateurs, ni accessibles, 
                ou bien le cas échéant sous une forme cryptée.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part mb-8">{anchorsParts[1].content}</p>
              <p className="help-text">
                Wodzone ajoute automatiquement certaines informations de base à votre profil. Toute information supplémentaire que vous choisissez d'ajouter est facultative. 
                C'est donc vous qui décidez des informations que vous fournissez, comme votre adresse, taille de vêtements pour les goodies etc.
              </p>
              <p className="help-text">
                L'intérêt principal de compléter votre profil est de simplifier vos démarches administratives d'inscription. Une fois votre profil renseigné, 
                vous gagnerez un temps précieux : les champs requis seront automatiquement pré-remplis pour vous et les futurs membres de votre équipe lors de 
                vos prochaines inscriptions.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[2].ref}>
              <p className="help-title-part mb-8">{anchorsParts[2].content}</p>
              <p className="help-text">
                Nous encourageons tous les utilisateurs à ajouter une photo de profil. Nous affichons la photo de profil des athlètes uniquement 
                dans le menu déroulant "Sélection des athlètes" lors d'une inscription à une compétition en équipe. 
                <a target='_blank' className="link" href={'/topics/compte/7'}>En savoir plus sur l'ajout ou la modification d'une photo de profil.</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicApercutProfil